<section class="relation-status">
  @if (readyForRequest || sharingRequested) {
    <h2 class="relation-status__title" i18n="@@employment.relations.advancedProfile">Erweitertes Profil</h2>
    <p class="relation-status__p" i18n="@@employment.relations.contentDataProtectionReason">Aus Datenschutzgründen
            ist nicht das vollständige Profil öffentlich ersichtlich. Falls sie mehr Daten wie Zeugnisse oder die
            Telefonnummer benötigen, können Sie eine Anfrage an {{ companionName }} stellen.</p>
  }

  @if (readyForRequest) {
    <button (click)="request()" [disabled]="(isLoading$ | async) !== false"
      class="button secondary"
      type="submit">
      <span aria-hidden="true" class="icon icon-head"></span>
      <ng-container i18n="@@employment.conversation.btnExchangeAdvancedProfile">Erweitertes Profil austauschen
        </ng-container>
    </button>
  }

  <div class="relation-status__info-box">
    @if (sharingRequested) {
      <div class="info-label">
        <div class="info-label__icon">
          <span aria-hidden="true" class="icon icon-pending"></span>
        </div>
        <div class="info-label__text" i18n="@@employment.relations.invitationIsPending">Die Team-Einladung ist
                pendent
            </div>
        <button (click)="decline()" [disabled]="(isLoading$ | async) !== false"
          class="button warning info-label__btn-abort"
          type="button">
          <ng-container i18n="@@employment.conversation.team.btnAbortRequest">Anfrage abbrechen</ng-container>
        </button>
      </div>
    }

    @if (answerNecessary) {
      <div class="info-label">
        <div class="info-label__icon">
          <span aria-hidden="true" class="icon icon-head"></span>
        </div>
        <div class="info-label__text" i18n="@@employment.relations.requestToShareProfile">Anfrage: Möchten Sie Ihr
                erweitertes Profil mit {{ companionName }} teilen?
            </div>
        <div class="info-label__actions">
          <button (click)="decline()" [disabled]="(isLoading$ | async) !== false" class="button warning"
            type="button">
            <ng-container i18n="@@employment.conversation.team.btnPrepareReply">Anfrage ablehnen</ng-container>
          </button>
          <button (click)="grant()" [disabled]="(isLoading$ | async) !== false" class="button secondary"
            type="button">
            <ng-container i18n="@@employment.conversation.team.btnAcceptRequest">Anfrage akzeptieren
                    </ng-container>
          </button>
        </div>
      </div>
    }

    @if (contactDataShared || isInTeam) {
      <div class="info-label info-label--green">
        <div class="info-label__icon">
          <span aria-hidden="true" class="icon icon-check"></span>
        </div>
        <div class="info-label__text" i18n="@@employment.relations.canSeeProfile">{{ companionName }} und Sie können
                gegenseitig ihr erweitertes Profil sehen
            </div>
      </div>
    }

    @if (contactDataShared) {
      <button (click)="revoke()" [disabled]="(isLoading$ | async) !== false"
        class="button warning revoke-access-btn"
        type="button">
        <ng-container i18n="@@employment.conversation.team.btnRevokeAccess">Zugriff auf erweitertes Profil
                entziehen
            </ng-container>
      </button>
    }
  </div>
</section>
